module.exports = __webpack_public_path__ + "img/Avatar-40.f0bcdd2e.svg";